import { Typography, Divider } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { Link } from "react-router-dom";

const TermsAndConditions = () => {
  const theme = useTheme();
  const styles = {
    intro: {
      color: `${theme.palette.primary.main}`,
    },
    para: {
      padding: "5px 0px 5px 20px",
    },
  };

  return (
    <div style={{ padding: "50px 80px" }}>
      <Typography variant="h4">Terms and Conditions</Typography>
      <br />
      <Divider />
      <br />

      <Typography variant="h6" gutterBottom style={styles.intro}>
        1. Acceptance of Terms
      </Typography>

      <Typography variant="body1" paragraph style={styles.para}>
        By using ACC Copilot, you agree to be bound by these Terms and
        Conditions, including any additional terms and conditions and policies
        referenced herein or made available by ACC Copilot
      </Typography>

      <Typography variant="h6" gutterBottom style={styles.intro}>
        2. License and Access
      </Typography>

      <Typography variant="body1" paragraph style={styles.para}>
        ACC Copilot grants you a limited, non-exclusive, non-transferable, and
        revocable license to use the application for its intended purposes.
      </Typography>

      <Typography variant="h6" gutterBottom style={styles.intro}>
        3. User Responsibilities
      </Typography>

      <Typography variant="body1" paragraph style={styles.para}>
        You are responsible for maintaining the confidentiality of your account
        information and for all activities occurring under your account.
      </Typography>

      <Typography variant="h6" gutterBottom style={styles.intro}>
        4. Privacy Policy
      </Typography>

      <Typography variant="body1" paragraph style={styles.para}>
        The use of ACC Copilot is also governed by our Privacy Policy. Please
        review the Privacy Policy for information on how we collect, use, and
        safeguard your data.
      </Typography>

      <Typography variant="h6" gutterBottom style={styles.intro}>
        5. Termination
      </Typography>

      <Typography variant="body1" paragraph style={styles.para}>
        ACC Copilot reserves the right to terminate or suspend your access to
        the application at any time, for any reason, without notice.
      </Typography>

      <Typography variant="h6" gutterBottom style={styles.intro}>
        6. Limitation of Liability
      </Typography>

      <Typography variant="body1" paragraph style={styles.para}>
        ACC Copilot and its affiliates shall not be liable for any direct,
        indirect, incidental, special, or consequential damages resulting from
        your use of the application or any third-party content.
      </Typography>

      <Typography variant="h6" gutterBottom style={styles.intro}>
        7. Changes to Terms and Conditions
      </Typography>

      <Typography variant="body1" paragraph style={styles.para}>
        ACC Copilot reserves the right to update and modify these Terms and
        Conditions at any time. Changes will be effective immediately upon
        posting on our website or within the ACC Copilot application.
      </Typography>

      <Typography variant="h6" gutterBottom style={styles.intro}>
        8. Contact Information
      </Typography>

      <Typography variant="body1" paragraph style={styles.para}>
        If you have any questions or concerns about these Terms and Conditions,
        please contact us at{" "}
        <Link
          to="mailto:info@cctech.co.in"
          style={{
            fontWeight: "bold",
            color: `${theme.palette.primary.main}`,
            textDecoration: "none",
          }}
        >
          info@cctech.co.in
        </Link>
        .
      </Typography>

      <Typography variant="h6" gutterBottom style={styles.intro}>
        9. Policy to Update Website
      </Typography>

      <Typography variant="body1" paragraph style={styles.para}>
        9.1. ACC Copilot's website may be updated from time to time to provide
        additional information, features, or improvements to the services
        offered. CCTech reserves the right to make changes to the website
        without prior notice. <br />
        <br />
        9.2. Updates to the website may include changes to user interfaces, new
        functionalities, bug fixes, or modifications to enhance the overall user
        experience. <br />
        <br />
        9.3. CCTech is committed to keeping the website up-to-date and ensuring
        that the information provided is accurate. However, there is no
        obligation to notify users individually about every website update.{" "}
        <br />
        <br />
        9.4. Users are encouraged to review the website regularly for any
        announcements, news, or changes. The "Last Updated" date at the bottom
        of the Terms and Conditions page indicates the latest revision. <br />
        <br />
        9.5. CCTech may, at its discretion, provide notifications about
        significant updates via email, in-app messages, or through other
        communication channels. <br />
        <br />
        9.6. Continued use of ACC Copilot after any website updates constitutes
        acceptance of the revised Terms and Conditions and any accompanying
        changes to the services. <br />
        <br />
        9.7. If you have any questions or concerns regarding website updates,
        please contact us at{" "}
        <Link
          to="mailto:info@cctech.co.in"
          style={{
            fontWeight: "bold",
            color: `${theme.palette.primary.main}`,
            textDecoration: "none",
          }}
        >
          info@cctech.co.in
        </Link>
        .
      </Typography>

      <Typography variant="h6" gutterBottom style={styles.intro}>
        10. Emergency Phone Numbers (India)
      </Typography>

      <Typography variant="body1" paragraph style={styles.para}>
        In case of emergencies related to ACC Copilot services in India, please
        contact the following emergency phone numbers:
        <br />- Emergency : <strong>100</strong>
        <br />- Technical Assistance: <strong>(+91) 74474 77868</strong>
      </Typography>

      <Typography variant="body1">
        Thank you for using ACC Copilot and abiding by these Terms and
        Conditions.
      </Typography>
      <br />
      <br />

      <Typography variant="subtitle1">Last Updated: 01-Jan-2024</Typography>
    </div>
  );
};

export default TermsAndConditions;
